import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import { isSimpleFood } from "utils"
import classes from "./FoodModalSpecifications.module.scss"

const FoodModalSpecifications = props => {
  const { form, setForm, options } = props

  const [t] = useTranslation()

  const handleSelectOption = (option) => {
    setForm(prev => ({
      ...prev,
      discount: 0,
      reduction: 0,
      salePrice: option.salePrice,
      optionId: option._id
    }))
  }

  const simpleFood = isSimpleFood(options)

  const isOutOfStock = (option) => (
    option.outOfStock ||
    (
      option.stockManagement &&
      option.availableQuantity <= 0
    )
  )

  if (simpleFood) return null

  return (
    <div className={classes["container"]}>
      <div className={classes["title"]}>
        {" "}{t("نوع_ها")}
      </div>

      <div className={classes["options"]}>
        {options.map(option =>
          option.isAvailable &&
          <button
            disabled={isOutOfStock(option)}
            key={option._id}
            onClick={() => handleSelectOption(option)}
          >
            <div
              className={clsx(
                classes["option-value"],
                form.optionId === option._id && classes.active
              )}
            >
              {option.name}
            </div>
          </button>
        )}
      </div>
    </div>
  )
}

export default FoodModalSpecifications